import Houses from '../components/Houses'
import NavBar from '../components/NavBar';

function Dashboard() {
    return (
      <div class='bg-violet-300 w-full h-full'>
        <NavBar/>
        <Houses/>
      </div>
    );
  }
  
  export default Dashboard;
  